import React from "react";
import { DrawerContext, DrawerContextProps } from "../contexts/drawer";

export const useDrawer = (): DrawerContextProps => {
  const { content, setIsOpen, isOpen, container, body } =
    React.useContext(DrawerContext);

  return {
    isOpen: isOpen,
    setIsOpen,
    content,
    container,
    body,
  };
};

export const useInitDrawer = (): DrawerContextProps => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const content: React.RefObject<HTMLDivElement> =
    React.useRef<HTMLDivElement>(null);

  const containerRef: React.RefObject<HTMLDivElement> =
    React.useRef<HTMLDivElement>(null);

  const bodyRef: React.RefObject<HTMLDivElement> =
    React.useRef<HTMLDivElement>(null);

  const context: DrawerContextProps = React.useMemo((): DrawerContextProps => {
    return {
      isOpen,
      content,
      setIsOpen,
      container: containerRef,
      body: bodyRef,
    };
  }, [isOpen]);

  return context;
};
